<template>
  <div>
    <div v-if="debug_show_page_name==true" style="color:green;">file-modal</div>
    <modal
      class="file-modal"
      width="1000px"
      :value="showModal"
      effect="fade"
      :backdrop="false" 
      @closed="closed('event')"
      large
    >
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <div style="font-size: 20px;padding: 0px 20px;font-weight: 800;">PDF</div>
      </div>
      <div class="contents" style="height: 450px;overflow-y: auto;">
        <div>
          <div
            v-if="error_msg.length > 0"
            style="margin: 30px;"
            class="alert alert-danger"
            v-html="error_msg"
          ></div>
          <div style="padding-top:10px;" v-if="error_msg.length == 0">
            <div
            style="width:220px;float:left;margin:4px;height: 250px;word-wrap: break-word;"
              v-for="f in existingFiles" :key="f.seq_id"> 
              <center>
              <a @click="editFile(f)" @dblclick="editAndOpenFile(f)">
                <pdf
                style="display: inline-block; width: 100px; border:solid #ccc 1px;"
                @error="pdfRenderError"
                :src="'/api/file_upload/pdf_load/'+f.seq_id+'?file=' + f.file_path + '&name=' + f.display_file_name"></pdf>
                <!-- <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-file-earmark-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0H4zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"/>
                </svg> -->
                <br>
                  {{f.display_file_name}}</a>
              <!-- <a :href="'/api/file_upload/pdf_load/'+f.seq_id+'?file=' + f.file_path" :target="'file' + f.seq_id"> LINK {{f.display_file_name}}</a> -->
              </center>
            </div>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer no_focus" style="background:white;height:100px;">
        <!-- <button
          type="button"
          class="btn btn-primary"
          style="background: #92D050;border-color:#92D050;"
          @click="startUpload()"
        >PDF取込</button>-->
        <div class="row no_focus" >
          <div class="col-xs-12" style="height:35px;" >
            <div v-if="editFileSelect" style="float:left;padding-bottom:15px;">
              {{editFileSelectItem.display_file_name}}
            </div>
          </div>
          <div class="col-xs-12 row no_focus">

            <div class="col-xs-6 no_focus">
              <a v-if="editFileSelect" style="display:none" name="selected_file" id="selected_file" ref="selected_file"
              :href="'/api/file_upload/pdf_load/'+editFileSelectItem.seq_id+'?file=' + editFileSelectItem.file_path + '&name=' + editFileSelectItem.display_file_name"  :target="'file' + editFileSelectItem.seq_id">{{editFileSelectItem.display_file_name}}</a>
                <button v-if="editFileSelect" type="button" class="btn btn-primary" style="background: #92D050;border-color:#92D050;float:left;" @click="openFile()">閲覧</button>
                <button v-if="editFileSelect" 
                :disabled="disableEditonButtons"
                type="button" class="btn btn-primary" style="float:left;" @click="renameFile()">名称変更</button>
                <button v-if="editFileSelect" 
                :disabled="disableEditonButtons"
                type="button" class="btn btn-primary" style="background: #FF7C80;border-color:#FF7C80;float:left;" @click="deleteFile()">削除</button>

          <!-- Upload objects start -->
              <input
                style="display: none;"
                @change="fileSelected"
                @click="fileClicked"
                type="file"
                name="pdf_file"
                id="pdf_file"
                data-cy="pdf_file"
                ref="pdf_file"
                accept="application/pdf"
              />

              <div v-if="uploading == true">
                <span
                  style="font-size: 30px; color: #5b9bd5;"
                  class="glyphicon glyphicon-refresh glyphicon-spin"
                ></span>
                アップロード中...
              </div>

              <div v-if="showUploadFile">
                <button
                  data-cy="upload_btn"
                  type="button"
                  style="min-width:120px;width: 10%;"
                  class="btn btn-primary"
                  @click="uploadFile({})"
                >アップロード</button>
                <button
                  type="button"
                  style="min-width:120px;width: 10%;background: #A6A6A6;border-color:#A6A6A6;"
                  class="btn btn-primary"
                  @click="cancelUpload"
                  v-if="showCancelUpload"
                >キャンセル</button>
                <label
                  v-if="this.selected_file_name != null && showUploadFile"
                >{{this.selected_file_name}}</label>
                <!-- Upload objects end-->
              </div>
            </div>
            <div class="col-xs-6 no_focus">
                <button
                  type="button"
                  class="btn btn-primary"
                  style="min-width:100px;width:200px;margin-right:20px;"
                  v-if="showChoseFile"
                  :disabled="disableEditonButtons"
                  @click="choseFile"
                >ファイルを選択（PDF）</button>
              <button type="button" class="btn btn-primary" @click="closed('button')">戻る</button>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <confirmation-modal tag="confirmToDeleteFile" @done="deleteFileConfirmed" />
    <input-modal2 tag="inputFileRename" @closed="renameFileConfirmed" ></input-modal2>
  </div>
</template>

<script>
import Vue from "vue";
// Vue.config.errorHandler = (err, vm, info) => {
//   console.log("Got errors",err, vm, info)

// };
// window.onerror = function(message, source, lineno, colno, error) {
//   console.log('Exception: ', error)
// }
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
import pdf from 'vue-pdf'
var vm = this;

import modal from "./local-modal";
import mixinPageCommon from "@/mixins/mixin_page_common";
import constants from "@/rules/constants";
import inputModal2 from "@/components/modals/input-modal2";
import axios from "axios";



Vue.component("modal", modal);
import _ from "lodash";
import debug from "debug";
var debug_file = debug("esma:file-modal");
export default {
  mixins: [mixinPageCommon],
  components: {
    "input-modal2": inputModal2,
    pdf
  },
  data() {
    return {
      uploadedImage: "",
      img_name: "",
      show_modal: false,
      selected_data: false,
      row_data: [],
      api_name: "certificate_information",
      search_timeout: false,
      search_model: "",

      // From here is neded.
      process_stage: "idle",
      file_selected_event: false,
      selected_file_name: null,
      error_msg: "",
      uploading: false,
      fk_id: "",
      existing_files:[],
      edit_file_select:false,
      edit_file_select_item:""
    };
  },
  computed: {
    disableEditonButtons(){
      var role = Vue.localStorage.get("userRole")
      return role == constants.PERMISSION.CHIEF_ADMINISTRATOR || role == constants.PERMISSION.ADMINISTRATOR
    },

    editFileSelectItem:{
      get(){
        return this.edit_file_select_item;
      },
      set(v){
        this.edit_file_select_item = v;
      }
    },
    editFileSelect:{
      get(){
        return this.edit_file_select;
      },
      set(v){
        this.edit_file_select = v;
      }
    },
    existingFiles:{
      get(){
        return this.existing_files;
      },
      set(v){
        this.existing_files = v;
      }
    },
    fkId: {
      get() {
        return this.fk_id;
      },
      set(v) {
        this.fk_id = v;
      },
    },
    showModal: {
      get() {
        return this.show_modal;
      },
      set(v) {
        this.show_modal = v;
      },
    },
    processStage: {
      get() {
        return this.process_stage;
      },
      set(v) {
        this.process_stage = v;
      },
    },
    showChoseFile() {
      return this.processStage == "idle";
    },
    showUploadFile() {
      return this.processStage == "file_selected";
    },
    showCancelUpload() {
      return this.processStage == "file_selected";
    },
  },
  methods: {
    pdfRenderError(err){
      console.log("pdfRenderError",err)
    },
    renameFileConfirmed(result){
      if(result.mode == "yes"){
        if(result.value.length > 0 && result.value != this.editFileSelectItem.display_file_name){
          this.$ajax.post("/file_upload/set/"+this.editFileSelectItem.seq_id,{
            changes:{
              display_file_name:result.value
            }
          },(err, result) => {
            if (err) {
              this.$notify({
                title: "名称変更に失敗しました。", 
                message:err,
                type: 'error',
                duration: 10000
              });
            } else {
              this.editFileSelect = false;
              this.loadData();
              this.$notify({
                title: "ファイルの名称が変更されました。",
                type: 'success',
                duration: 3000
              });
            }
          })
        }
      }
    },
    renameFile(){
      bus.$emit("inputFileRename", {
            title: "名称変更",
            initial_value:this.editFileSelectItem.display_file_name
          });
    },
    deleteFile(){
      console.log("Delete the file "+this.editFileSelectItem.display_file_name+"？")
      // Need to confirm, then delete
      bus.$emit("confirmToDeleteFile",{
        message: ""+this.editFileSelectItem.display_file_name+"を削除しますか？ ",
        title: "削除",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"primary",
        no_color:"info",
        model_height:"50"
      });
    },
    deleteFileConfirmed(mode){
      if(mode == "yes"){
        this.$ajax.post("/file_upload/delete/",{
          seq_id:this.editFileSelectItem.seq_id,
          seq_id_match3:this.editFileSelectItem.seq_id * 3
        },(err, result) => {
          if (err) {
            this.$notify({
              title: "ファイルの削除に失敗しました。",
              type: 'error',
              duration: 10000
            });
          } else {
            this.loadData();
            this.$notify({
              title: "ファイルが削除されました。",
              type: 'success',
              duration: 3000
            });
            this.editFileSelect = false;
          }
        })
      }
    },
    openFile(){
      var selected_file = this.$refs.selected_file;
      selected_file.click();
    },
    editAndOpenFile(file){
      this.editFile(file);
      setTimeout(() => {
        this.openFile();
      }, 50);
    },
    editFile(file){
      this.editFileSelectItem = file;
      this.editFileSelect = true;
    },
    loadData() {
      var obj = {
        filter: {
          1: {
            block: "1",
            field: "fk_id",
            value: this.fkId + "",
            ct: "v",
            ca: false,
            t: "input",
            exact_value:true
          },
          2: {
            block: "2",
            field: "fk_tab",
            value: constants.TABLE_ID.CERTIFICATE + "",
            ct: "v",
            ca: false,
            t: "input",
            exact_value:true
          },
          3: false,
          j1: "AND",
          j2: "AND",
          b2_disabled: false,
          b3_disabled: false,
        },
      };
      this.$ajax.post("/file_upload/datasource_load/0/1000",obj,(err, result) => {
        if(err == null){
          this.existingFiles = result;
        }else{
          this.existingFiles = [];
          this.error_msg = err;
        }
      });
    },
    fileSelected(e) {
      var files = e.target.files;
      if (!files[0]) {
        return;
      }
      this.processStage = "file_selected";
      this.file_selected_event = e;
      this.selected_file_name = files[0].name;
    },
    choseFile() {
      this.editFileSelect = false;
      var pdf_file = this.$refs.pdf_file;
      pdf_file.click();
    },
    fileClicked(e) {
      var pdf_file = this.$refs.pdf_file;
      pdf_file.value = null;
    },
    closed(mode) {
      this.$emit("close", {mode, qty:(this.existingFiles)?this.existingFiles.length:0});
      this.showModal = false;
    },
    showModalWindow(data) {
      this.fkId = data.fk_id;
      this.error_msg = "";
      this.showModal = true;
      this.loadData()
    },
    uploadFile(options) {
      this.error_msg = "";
      this.processStage = "uploading";
      this.uploading = true;
      var files = this.file_selected_event.target.files;
      if (!files[0]) {
        return;
      }
      var form_data = new FormData();
      form_data.append("pdf", files[0]);
      form_data.append("fk_id", this.fkId);
      form_data.append("fk_tab", constants.TABLE_ID.CERTIFICATE);
      axios
        .post(this.$ajax.serverUrl + "/file_upload/pdf_upload/", form_data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          var data = response.data;
          if (response.data.success == true) {
            this.uploading = false;
            this.loadData();
            return (this.processStage = "idle");
          } else {
            this.uploading = false;
            try {
              this.error_msg =
                "エラー ：" +
                JSON.stringify(response.data.error).replace(/"/g, "") +
                "";
            } catch (error) {
              this.error_msg = "エラー ：" + response.data.error + "";
            }

            this.processStage = "preview_error";
            this.file_selected_event = null;
            this.selected_file_name = null;
            this.uploading = false;
          }
        })
        .catch((error) => {
          this.error_msg = "エラー ：：： (" + error + ")";

          this.processStage = "preview_error";
          this.file_selected_event = null;
          this.selected_file_name = null;
          this.uploading = false;
        });
    },
    cancelUpload() {
      this.selected_file_name = null;
      this.file_selected_event = null;
      this.processStage = "idle";
    },
  },
  props: {
    tag: { type: String, default: "showfileModal" },
  },
  beforeMount() {},
  mounted() {
    debug_file("On mounted");
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
};
</script>
<style>
.no_focus::-moz-selection { /* Code for Firefox */
  background: white;
}
.no_focus::selection {
  background: white;
}
</style>
<style scoped>
.no_focus::-moz-selection { /* Code for Firefox */
  background: white;
}
.no_focus::selection {
  background: white;
}
.info_div {
  width: 32%;
  float: left;
}
.mh_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.mh_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
.fa-spin-custom,
.glyphicon-spin {
  -webkit-animation: spin 1500ms infinite linear;
  animation: spin 1500ms infinite linear;
}
label > input {
  display: none;
}

label {
  padding: 1rem 1rem;
  /* border: solid 1px #888; */
}

label::after {
  /* content: "+"; */
  font-size: 1rem;
  color: #888;
  padding-left: 1rem;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>



// WEBPACK FOOTER //
// file-modal.vue?265f6076